import type {ReactNode} from 'react';
import {Button, BlockStack} from '@shopify/polaris';
import {useI18n} from '@shopify/react-i18n';

interface FilterPopoverProps {
  filter: ReactNode;
  hideClearButton?: boolean;
  onClear(): void;
}

export function FilterPopover({
  filter,
  hideClearButton,
  onClear,
}: FilterPopoverProps) {
  const [i18n] = useI18n();

  const clearButtonMarkup = !hideClearButton && (
    <Button
      variant="plain"
      disabled={!onClear}
      onClick={onClear}
      accessibilityLabel={i18n.translate('clearFilter')}
    >
      {i18n.translate('clear')}
    </Button>
  );

  return (
    <>
      <BlockStack gap="200" inlineAlign="start">
        {filter}
        {clearButtonMarkup}
      </BlockStack>
    </>
  );
}
